<script lang="ts" setup>
import { AppLink } from '#components'

defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
})

// const { settings } = useSliderSettings()
// const sliderSettings = Object.assign({}, settings, {
//   itemsToShow: 1.5,
//   breakpoints: {
//     700: {
//       itemsToShow: 3,
//       itemsToScroll: 3,
//     },
//     1024: {
//       itemsToShow: 4,
//       itemsToScroll: 4,
//     },
//   },
// })

// const carousel = ref()
// const showNavigation = computed(() => {
//   return carousel.value?.data?.slidesCount.value > carousel.value?.data?.config?.itemsToShow
// })
</script>

<template>
  <StrapiSlice
    v-if="slice.Cards"
    class="ct-category-feed"
    :slice="slice"
    :index="index"
  >
    <UiCarousel
      class="ct-category-feed__carousel"
      :class="{
        /* Non responsive & non modern settings */
        'ui-carousel--center': false,
        'ui-carousel--free-scroll': true,
        'ui-carousel--navigation': true,
        'ui-carousel--pagination': false,
        'ui-carousel--progress': false,
      }"
      :style="`--items: ${slice?.Cards?.length}`"
    >
      <template
        v-for="(card, i) in slice?.Cards"
        #[`slide-${i}`]
        :key="card"
      >
        <div
          v-if="card?.Image?.url"
          class="category-feed-item__cta"
          :class="{
            'category-feed-item__cta--has-background': !slice?.Settings?.BackgroundColor,
          }"
        >
          <img
            :src="useXcdnImage(card.Image.url, 'f=rs:fit:400')"
            :alt="card.Image.alternativeText || card.Title || ''"
            :height="card.Image.height"
            :width="card.Image.width"
            loading="lazy"
            fetchpriority="auto"
            decoding="async"
          >
          <AppLink
            :to="card.Link || '#'"
            class="category-feed-item__title"
          >
            <span>{{ card.Title }}</span>
          </AppLink>
        </div>
      </template>
    </UiCarousel>
  </StrapiSlice>
</template>

<style>
@import url("~layers/app/components/Slices/CategoryFeed.css");
</style>
